<template>
	<el-dialog :title="title" :close-on-click-modal="false" :visible.sync="visible" width="1000px">
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="115px" class="border-form"
			:inline="true" style="margin-right: 25px;">
			<el-row class="set_border"> 
				<el-col :span="12" class="col-set_border">
					<el-form-item label="标的物" class="item">
						{{ dataForm.subjectName }}
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="专业" class="item">
						{{ dataForm.majorName }}
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="set_border">
				<el-col :span="24">
					<el-form-item label="部件" class="item">
						{{ dataForm.partsName }}
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="set_border">
				<el-col :span="24">
					<el-form-item label="检验项目" class="item">
						{{ dataForm.probContext }}
					</el-form-item>
				</el-col>
			</el-row>

			<!-- 动态渲染检验记录 -->
			<div class="inspection_block" v-for="(record, index) in sortedInspectionRecords" :key="index">
				<div class="inspection_title">{{getTestTimes(record.testTimes)}}</div>

				<el-row class="set_border">
					<el-col :span="24">
						<el-form-item label="检验意见" class="item long-content-item">
							<div class="long-text-content">{{ record.sutContent || '暂无' }}</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="6" class="col-set_border">
						<el-form-item label="检验结论" class="item">
							{{ getConclusionName(record) || '暂无' }}
						</el-form-item>
					</el-col>
					<el-col :span="9" class="col-set_border">
						<el-form-item label="检验人" class="item">
							{{ record.testMan || '暂无' }}
						</el-form-item>
					</el-col>
					<el-col :span="9" class="col-set_border">
						<el-form-item label="检验时间" class="item">
							{{ record.testDate | formatDate('yyyy-MM-dd') }}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" class="row-form-item">
						<div class="fileItem">检验照片（如有时）</div>
					</el-col>
				</el-row>
				<el-row class="inspection_photo">
					<el-col :span="24">
						<div class="addImgBox" v-for="(item, idx) in record.scenePhotoList"
							style="margin-top: 5px;margin-bottom: 10px;" :key="idx">
							<el-image style="width: 100%; height: 100%" :src="item.fileUri" fit="cover"></el-image>
						</div>
						<div v-if="!record.scenePhotoList || record.scenePhotoList.length === 0">
							<span style="color: #e7b243;">暂无检验照片</span>
						</div>
					</el-col>
				</el-row>
				<el-row v-if="showClose(record)" class="set_border">
					<el-col :span="12" class="col-set_border">
						<el-form-item label="封闭时间" class="item">
							{{ record.closeTime | formatDate('yyyy-MM-dd') || '暂无' }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="封闭人" class="item">
							{{ record.closeMan || '暂无' }}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="showClose(record)" class="set_border">
					<el-col :span="24">
						<el-form-item label="备注" class="item long-content-item">
							<div class="long-text-content">{{ record.remark || '暂无' }}</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="showClose(record)" class="set_border">
					<el-col :span="24">
						<el-form-item label="封闭时状况描述" class="item long-content-item">
							<div class="long-text-content">{{ record.closeDescribe || '暂无' }}</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="showClose(record)">
					<el-row>
						<el-col :span="24" class="row-form-item">
							<div class="fileItem">“有条件接受”封闭时照片（如有时）</div>
						</el-col>
					</el-row>
					<el-row style="margin-top: 20px;">
						<el-col :span="16">
							<div class="addImgBox" v-for="(item, idx) in record.closePhotoList"
								style="margin-bottom: 10px;" :key="'closePhoto' + idx">
								<el-image style="width: 100%; height: 100%" :src="item.fileUri" fit="cover"></el-image>
								<div class="delBox">
									<i class="el-icon-delete" @click="delClosePhoto(idx)"></i>
								</div>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24" class="row-form-item">
							<div class="fileItem">“有条件接受”封闭时附件（如有时）</div>
						</el-col>
					</el-row>
					<el-row style="margin-top: 20px;">
						<el-col :span="16">
							<el-table :data="record.closeFileList" :cell-style="{ padding: '0px' }"
								style="margin-bottom: 20px;" :show-header="false"
								v-if="record.closeFileList && record.closeFileList.length > 0">
								<el-table-column width="100" align="center" type="index">
								</el-table-column>
								<el-table-column prop="fileName" width="350" align="center">
									<template slot-scope="scope">
										<el-input class="sp-input" v-model="scope.row.fileName"></el-input>
									</template>
								</el-table-column>
								<el-table-column width="150" align="center">
									<template slot-scope="scope">
										<el-button v-preventReClick type="text" size="small"
											@click="selectFile(scope.row.fileUri, scope.row.fileName)">查看</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="delCloseFile(scope.$index)">删除</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
				</el-row>
			</div>

			<el-row class="formBtnGroup" style="margin-top: -10px;">
				<el-button v-preventReClick class="btn" type="primary" size="small"
					@click="visible = false">取消</el-button>
			</el-row>
		</el-form>
		<view-pdf v-if="viewPdfVisible" ref="viewPdf" @refreshDataList="dataList"></view-pdf>
	</el-dialog>
</template>

<script>
import addImg from "@/assets/images/addImg.png"
import $common from "@/utils/common.js"
import ViewPdf from "../projectInfo/viewPdf.vue"
export default {
	name: "patrolList-Info",
	data() {
		return {
			viewPdfVisible: false,
			title: '详情',
			addImg: addImg,
			categoryList: [],
			sutConclusionList: [],
			testId: '',
			visible: true,
			action: "",
			form: {},
			probCheck: '0',
			dataForm: {
				workNo: $common.getItem("workNo"),
				subjectNo: "",
				inspectionId: "",
				category: '',
				major: "",
				inspectionTime: "",
				inspectionPlace: "",
				inspectionMan: '',
				inspectionContent: '',
				photo: [],
				sutContent: '',
				problem: {}
			},
			dataRule: {},
			dataList: []
		};
	},
	components: {
		ViewPdf
	},
	computed: {
		// 计算属性，根据testTimes排序检验记录
		sortedInspectionRecords() {
			return this.dataList.slice().sort((a, b) => parseInt(a.testTimes) - parseInt(b.testTimes));
		}
	},
	watch: {
		// 监听dataList变化，更新排序后的检验记录
		dataList: {
			handler(newVal) {
				if (newVal && newVal.length > 0) {
					// 不再给计算属性赋值，因为计算属性会自动重新计算
					// this.sortedInspectionRecords = newVal.slice().sort((a, b) => parseInt(a.testTimes) - parseInt(b.testTimes));

					// 更新基础信息，取第一条记录的基础信息
					const firstRecord = newVal[0];
					this.dataForm = {
						...this.dataForm,
						subjectName: firstRecord.subjectName,
						majorName: firstRecord.majorName,
						partsName: firstRecord.partsName,
						probContext: firstRecord.probContext,
						sutContent: firstRecord.sutContent
					};
				}
			},
			deep: true
		}
	},
	mounted() {
		// this.testId = this.$route.query.testId;
		// this.getDetail();
	},
	filters: {
		formatDate: function (value, args) {
			if (!value) {
				return ''
			}
			var dt = new Date(value);
			if (args == 'yyyy-M-d') {// yyyy-M-d
				let year = dt.getFullYear();
				let month = dt.getMonth() + 1;
				let date = dt.getDate();
				return `${year}-${month}-${date}`;
			} else if (args == 'yyyy-M-d H:m:s') {// yyyy-M-d H:m:s
				let year = dt.getFullYear();
				let month = dt.getMonth() + 1;
				let date = dt.getDate();
				let hour = dt.getHours();
				let minute = dt.getMinutes();
				let second = dt.getSeconds();
				return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
			} else if (args == 'yyyy-MM-dd') {// yyyy-MM-dd
				let year = dt.getFullYear();
				let month = (dt.getMonth() + 1).toString().padStart(2, '0');
				let date = dt.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${date}`;
			} else {// yyyy-MM-dd HH:mm:ss
				let year = dt.getFullYear();
				let month = (dt.getMonth() + 1).toString().padStart(2, '0');
				let date = dt.getDate().toString().padStart(2, '0');
				let hour = dt.getHours().toString().padStart(2, '0');
				let minute = dt.getMinutes().toString().padStart(2, '0');
				let second = dt.getSeconds().toString().padStart(2, '0');
				return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
			}
		}
	},
	methods: {
		getTestTimes(testTimes) {
			if(testTimes < 3) {
				return testTimes + "次检验"
			}
			return "2次以上检验"
		},
		goBack() {
			this.$router.back()
		},
		init(id) {
			this.testId = id ? id : '';
			if (id) {
				this.getDetail();
			}
			this.$nextTick(() => {
				this.visible = true;
			});
			if (this.$refs) {
				this.$refs["dataForm"].resetFields();
			}
		},
		viewPdf(filePath, fileUri, filename) {
			// pdf和doc文件，需要pdf在线预览，其他类型文件直接下载
			let suffixType = fileUri.substr(fileUri.lastIndexOf(".") + 1)
			if (suffixType != '' && (suffixType === 'pdf' || suffixType === 'doc' || suffixType === 'docx')) {
				// $common.viewFile(filePath)
				this.viewPdfVisible = true;
				this.$nextTick(() => {
					this.$refs.viewPdf.init(filename, filePath)
				})
			} else {
				filename = this.getSuffix(fileUri, filename)
				this.getBlob(fileUri, (blob) => {
					this.saveAs(blob, filename)
				})
			}
		},
		downloadFile(fileUri, filename) {
			filename = this.getSuffix(fileUri, filename)
			this.getBlob(fileUri, (blob) => {
				this.saveAs(blob, filename)
			})
		},
		getSuffix(url, filename) {
			let lastIndex = url.lastIndexOf(".");
			return filename + url.substr(lastIndex)
		},
		getBlob(url, cb) {
			var xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.responseType = 'blob'
			xhr.onload = function () {
				if (xhr.status === 200) {
					cb(xhr.response)
				}
			}
			xhr.send()
		},
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			}
			else {
				var link = document.createElement('a')
				var body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob)
				link.download = filename

				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)
				window.URL.revokeObjectURL(link.href)
			}
		},
		getDetail() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/testrecord/getTestRecordListByRecSortNum/" + this.testId,
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataList = data.body;
				}
			});
		},
		getCategoryName(categoryId) {
			this.categoryList.forEach((item) => {
				if (categoryId === item.displayValue) {
					return item.displayName
				}
			})
		},
		// 获取检验结论名称
		getConclusionName(record) {
			const times = record.testTimes;
			if (times === '1') {
				return record.testConclusionName1;
			} else if (times === '2') {
				return record.testConclusionName2;
			} else if (times === '3') {
				return record.testConclusionName3;
			} else {
				// 如果是其他次数，返回通用的结论名
				return record[`testConclusionName${times}`] || record.finalConclusionName;
			}
		},
		// 判断是否显示封闭内容
		showClose(record) {
			const times = record.testTimes;
			if (times === '1' && record.testConclusion1 == '2') {
				return true;
			} else if (times === '2' && record.testConclusion2 == '2') {
				return true;
			} else if (times === '3' && record.testConclusion3 == '2') {
				return true;
			}
			return false;
		},
		delClosePhoto(index) {
			// 由于现在是动态渲染的多个检验记录，需要在方法中处理正确的记录
			// 这里仅作为占位符，实际实现需要传入对应的record
		},
		selectFile(fileUri, fileName) {
			// 查看文件方法
		},
		delCloseFile(index) {
			// 删除文件方法
		}
	},
};
</script>

<style lang="scss" scoped>
.border-form {
	width: 100%;
	.el-row.set_border {
		align-items: stretch;
		display: flex;
	}
}

/* 修改表单项基础样式 */
.item::v-deep .el-form-item__label {
	margin: 0px !important;
	color: #00428e !important;
	background-color: #E1F1FF;
	height: 100% !important;
	min-height: 40px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	text-align: right;
	box-sizing: border-box;
	border: 1px solid #dadada;
}

/* 修改表单项容器样式 */
::v-deep .el-form-item {
	display: flex !important;
	align-items: stretch !important;
	margin: 0px !important;
	height: 100%;
	min-height: 40px;
	margin-bottom: 4px !important;
	.el-form-item__content {
		flex: 1;
		display: flex;
		align-items: center;
		padding: 8px 12px;
		box-sizing: border-box;
		line-height: 1.5;
		font-size: 14px;
		color: #333;
		border: 1px solid #dadada;
	}
}

/* 长文本内容项的特殊样式 */
.long-content-item::v-deep .el-form-item__label {
	align-items: center;
	height: auto !important;
}

.long-content-item::v-deep .el-form-item__content {
	align-items: flex-start;
}

/* 长文本内容样式 */
.long-text-content {
	white-space: pre-wrap !important;
	/* 保留空白符并允许换行 */
	word-wrap: break-word !important;
	/* 长单词自动换行 */
	word-break: break-all !important;
	/* 强制换行 */
	overflow-wrap: break-word !important;
	/* 兼容性 */
	width: 100%;
	min-height: 20px !important;
  	height: auto;
  	overflow: visible;
	padding: 0;
	margin: 0;
	display: block;
}

/* 确保所有表单项内容区域正确显示 */
::v-deep .el-form-item__content {

	>span,
	>div {
		width: 100%;
	}
}

.fileItem {
	padding: 10px 5px;
	text-align: left;
	color: #00428e !important;
	font-weight: bold !important;
	width: 100% !important;
	background-color: #E1F1FF;
}

/* 响应式调整 */
@media screen and (max-width: 1200px) {
	.border-form {
		margin-right: 15px;
	}

	.long-text-content {
		font-size: 13px;
	}
}

.selItemInput.descAreaLg {
	width: 718px !important;
}

.selItemInput.descAreaLg1 {
	width: 918px !important;
}

.addImgBox {
	width: 136px;
	height: 136px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 10px;
}

.inspection_block {
	margin-top: 2px;
	margin-bottom: 5px;
}
.inspection_title {
	font-size: 16px;
	background-color: #E1F1FF;
	padding-left: 20px;
	width: 100% !important;
	height: 40px !important;
	font-weight: bold;
	padding-top: 10px;
	padding-bottom: 10px;
}

.inspection_photo {
	margin: 10px 15px;
}

/* 按钮样式调整 */
.formBtnGroup {
    display: flex;
    justify-content: center;
    margin-top: 20px !important;
    text-align: center;
    
    .btn {
        width: 100px;
    }
}
</style>
